export const ErrorMessageServeDefault = `Error: Desculpe, parece que encontramos um problema no servidor. Por favor, 
tente novamente mais tarde. Se o problema persistir, entre em contato com o suporte técnico. 
Agradecemos pela sua compreensão.`;
